export default __webpack_public_path__ + "slices/main/assets/public/fonts/inter/inter-regular.c70cc74045523eb2536e91d1e39b99b8.woff";